import script from "./approvalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./approvalPage.vue?vue&type=script&setup=true&lang=js"

import "./approvalPage.vue?vue&type=style&index=0&id=2d767042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d767042"]])

export default __exports__